export default __webpack_public_path__ + "static/media/template3.d38b0f62.png";